












































































import draggable from 'vuedraggable';
import {Component, Vue, Watch} from 'vue-property-decorator';
import {Getter, Action} from 'vuex-class';
import Card from '../../../components/material/Card.vue';

@Component({
  components: {
    Card,
    draggable,
  },
})
export default class DlgArticleEmailGenerator extends Vue {
  @Getter('articles/all') private articles!: any[];
  @Getter('newsletter/generatedExternal') private generatedEmail!: string;
  @Action('newsletter/generate') private generate!: any;
  private localArticles: any = [];
  private articleList: any = [];
  private loading: boolean = false;
  private dialog: boolean = false;

  @Watch('dialog')
  private dialogWatcher() {
    this.localArticles = JSON.parse(JSON.stringify(this.articles));
    this.articleList = [];
  }

  private async generateNewsletter() {
    this.loading = true;
    await this.generate(this.articleList);
    this.loading = false;
  }
}
